import { writable } from "svelte/store"

export const profile = writable({found: false})